import { FilterDefinitionsKeys } from 'hooks/useFilters/useFilters';

export const multiSelectValueHelper = <TData>({
  statusKey,
  newValue,
  allActiveFilters,
}: {
  statusKey: keyof TData;
  newValue: string | string[];
  allActiveFilters: Partial<{ [key in FilterDefinitionsKeys<TData>]: string[] }>;
}) => {
  const selectedSeveritys = allActiveFilters[statusKey] ?? [];
  if (Array.isArray(newValue) && newValue.length === 0) {
    return [];
  }
  const formatedNewValue = Array.isArray(newValue) ? newValue : [newValue];

  const valueExists = formatedNewValue.some((item) => selectedSeveritys.includes(item));

  if (valueExists) {
    return selectedSeveritys.filter((item: string) => !formatedNewValue.includes(item));
  }
  return [...selectedSeveritys, ...formatedNewValue];
};
